export default __webpack_public_path__ + "static/media/103.e51cc2b8.jpg";